export function Icon({ name, size = 20 }: { name: string; size?: number }) {
  const paths: Record<string, string> = {
    coffee:
      "M4 8h12v9a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Zm12 1h2a3 3 0 1 1 0 6h-2M7 2v3m5-3v3",
    food: "M5 2v7m4-7v7M3 2v5a4 4 0 0 0 8 0V2M7 11v11M20 2c-4 2-5 6-5 10h5m0-10v20",
    mountain: "M2 20 9 5l4 8 3-5 6 12H2Z M6 12l3 2 3-3",
    calendar:
      "M8 2v4m8-4v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14H3V6a2 2 0 0 1 2-2Z M7 14h3m4 0h3m-10 3h3",
    map: "m3 5 6-3 6 3 6-3v17l-6 3-6-3-6 3V5Zm6-3v17m6-14v17",
    check: "m5 12 4 4L19 6",
    list: "M9 6h12M9 12h12M9 18h12M3 6h1m-1 6h1m-1 6h1",
    bed: "M3 18v3m18-3v3M3 18h18v-6H3v6Zm2-6V5h14v7M7 8h3m4 0h3",
    arrow: "M4 12h16m-6-6 6 6-6 6",
    download: "M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5",
    pin: "M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z M14 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
    plus: "M12 5v14M5 12h14",
    minus: "M5 12h14",
    plane: "m22 2-7 20-4-9-9-4 20-7Zm0 0L11 13",
    clock: "M12 8v5l3 2M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0",
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name] ?? paths.list} />
    </svg>
  );
}
